<template>
  <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
    <form class="space-y-16" @submit.prevent="handleSubmit(submit)">
      <div class="space-y-8">
        <div class="space-y-1">
          <h3 class="text-indigo-500">
            {{ $t('newRole') | capitalize }}
          </h3>
        </div>
        <ValidationProvider
          name="name"
          vid="name"
          rules="required"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup class="w-full">
            <BaseFormLabel for="name"> Name * </BaseFormLabel>
            <BaseFormInput
              id="name"
              v-model="roleData.name"
              :disabled="submitting"
              :invalid="failed"
              placeholder="enter name..."
              v-select
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>

        <ValidationProvider
          name="scope"
          vid="scope"
          rules="required"
          v-slot="{ errors, failed }"
          slim
        >
          <BaseFormGroup>
            <BaseFormSelect
              v-model="roleData.scope"
              :options="scopeOptions"
              :disabled="submitting"
              :invalid="failed"
              placeholder="enter phone number"
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>

        <ValidationProvider name="description" vid="description" v-slot="{ errors, failed }" slim>
          <BaseFormGroup>
            <BaseFormLabel> Description </BaseFormLabel>
            <BaseFormTextarea
              v-model="roleData.description"
              rows="5"
              :disabled="submitting"
              placeholder="enter description..."
            />
            <BaseFormInlineMessage v-if="failed" danger>
              {{ errors[0] }}
            </BaseFormInlineMessage>
          </BaseFormGroup>
        </ValidationProvider>
      </div>
      <div class="space-x-2 text-right">
        <BaseButton ghost type="button" :disabled="submitting" @click="backToRoles">
          Cancel
        </BaseButton>
        <BaseButton type="submit" primary :disabled="submitting || invalid"> Create </BaseButton>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'FormCreate',
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    roleData: {
      name: '',
      scope: '',
      description: '',
    },
    scopeOptions: [
      { value: 'web', label: 'Web' },
      { value: 'account member', label: 'Account member' },
    ],
  }),
  methods: {
    handleCheckbox(ev) {
      const { checked } = ev.target;
      this.roleData.package = checked;
    },
    submit() {
      this.submitRoleData();
    },
    submitRoleData() {
      this.$emit('submit', { ...this.roleData });
    },
    backToRoles() {
      this.$router.replace({ name: 'admin.roles' });
    },
  },
};
</script>
